import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _MoreVertIcon, _ListItemText, _ListItemText2;
import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { styled } from '@mui/material/styles';
import { useFormatDate } from './useFormatDate';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var NotificationItem = function NotificationItem(_ref) {
  var dismiss = _ref.dismiss,
    item = _ref.item,
    markAsReadItem = _ref.markAsReadItem,
    onNotificationItemClick = _ref.onNotificationItemClick,
    _ref$showWelcomeMsg = _ref.showWelcomeMsg,
    showWelcomeMsg = _ref$showWelcomeMsg === void 0 ? false : _ref$showWelcomeMsg;
  var action = item.action,
    content = item.content,
    createdDate = item.createdDate,
    isRead = item.isRead,
    title = item.title;
  var formatDate = useFormatDate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMenuPopover = _useState2[0],
    setShowMenuPopover = _useState2[1];
  var menuAnchorEl = useRef(null);
  var handleMenuOpen = function handleMenuOpen(event) {
    menuAnchorEl.current = event.currentTarget;
    setShowMenuPopover(true);
  };
  var handleMenuClose = function handleMenuClose() {
    setShowMenuPopover(false);
  };
  return /*#__PURE__*/_jsxs(Box, {
    p: 2,
    sx: {
      backgroundColor: isRead ? 'white' : '#F3FAFF',
      borderTop: '1px solid #E3E3E3',
      cursor: !isRead ? 'pointer' : 'auto',
      position: 'relative'
    },
    "data-element": "Box",
    "data-component": "NotificationItem",
    "data-source-file": "NotificationItem.tsx",
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-label": "More options",
      onClick: handleMenuOpen,
      sx: {
        position: 'absolute',
        right: 8,
        top: 8
      },
      "data-element": "IconButton",
      "data-source-file": "NotificationItem.tsx",
      children: _MoreVertIcon || (_MoreVertIcon = /*#__PURE__*/_jsx(MoreVertIcon, {
        "data-element": "MoreVertIcon",
        "data-source-file": "NotificationItem.tsx"
      }))
    }), /*#__PURE__*/_jsx(Popover, {
      anchorEl: menuAnchorEl.current,
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'top'
      },
      onClose: handleMenuClose,
      open: showMenuPopover,
      transformOrigin: {
        horizontal: 'right',
        vertical: 'top'
      },
      "data-element": "Popover",
      "data-source-file": "NotificationItem.tsx",
      children: /*#__PURE__*/_jsxs(Paper, {
        sx: {
          borderRadius: '2px',
          boxShadow: '3px',
          padding: '2px'
        },
        "data-element": "Paper",
        "data-source-file": "NotificationItem.tsx",
        children: [!(item != null && item.isRead) && /*#__PURE__*/_jsx(MenuItem, {
          onClick: function onClick() {
            markAsReadItem();
            handleMenuClose();
          },
          children: _ListItemText || (_ListItemText = /*#__PURE__*/_jsx(ListItemText, {
            children: "Mark as Read"
          }))
        }), /*#__PURE__*/_jsx(MenuItem, {
          onClick: function onClick() {
            dismiss();
            handleMenuClose();
          },
          "data-element": "MenuItem",
          "data-source-file": "NotificationItem.tsx",
          children: _ListItemText2 || (_ListItemText2 = /*#__PURE__*/_jsx(ListItemText, {
            "data-element": "ListItemText",
            "data-source-file": "NotificationItem.tsx",
            children: "Dismiss"
          }))
        })]
      })
    }), /*#__PURE__*/_jsx(Stack, {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between",
      "data-element": "Stack",
      "data-source-file": "NotificationItem.tsx",
      children: title && /*#__PURE__*/_jsx(Typography, {
        fontSize: "14px",
        fontWeight: isRead ? 400 : 600,
        lineHeight: "28px",
        ml: 2.25,
        children: title
      })
    }), /*#__PURE__*/_jsx(StyledTypography, {
      fontSize: "14px",
      lineHeight: "22px",
      ml: 2.25,
      onClick: function onClick() {
        onNotificationItemClick();
      },
      "data-element": "StyledTypography",
      "data-source-file": "NotificationItem.tsx",
      children: content
    }), action && action.call && /*#__PURE__*/_jsx(Button, {
      onClick: action.call,
      size: "small",
      sx: {
        fontSize: 14,
        height: 32,
        ml: 2.25,
        mt: 2,
        textTransform: 'none'
      },
      variant: "contained",
      children: action.caption
    }), createdDate && /*#__PURE__*/_jsx(Typography, {
      sx: {
        color: '#999999',
        fontSize: 12,
        lineHeight: 2,
        ml: 2.25,
        mt: 1.5
      },
      children: formatDate(createdDate)
    })]
  });
};

// Styled component for content truncation
var StyledTypography = styled(Typography)({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '90%'
});